import { getAdminCpList } from './cp';

const PAGE_SIZE = 100;
const MAX_PAGES = 1000;

const fail = () => new Error('전체 가맹점 목록을 확인하지 못했습니다. 다시 조회해 주세요.');

function numberField(value) {
  if (value === undefined || value === null) return null;
  if ((typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value))) || !Number.isSafeInteger(Number(value)) || Number(value) < 0) throw fail();
  return Number(value);
}

/** Load complete, distinct CP rows. Never return a partial result as complete. */
export async function fetchAllUnmeMerchants() {
  const rows = [];
  const seen = new Set();
  let expectedTotal = null;
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const response = await getAdminCpList({ page, limit: PAGE_SIZE });
    const items = Array.isArray(response) ? response : response?.rows ?? response?.list;
    if (!Array.isArray(items)) throw fail();
    const meta = !Array.isArray(response) && response && typeof response === 'object' ? response : {};
    const rawTotal = meta.total ?? meta.totalCount ?? meta.total_count ?? meta.pagination?.total;
    const total = numberField(rawTotal);
    if (total !== null && expectedTotal !== null && total !== expectedTotal) throw fail();
    if (total !== null) expectedTotal = total;
    const rawPage = meta.page ?? meta.pagination?.page;
    if (rawPage != null && numberField(rawPage) !== page) throw fail();
    const rawHasNext = meta.hasNext ?? meta.has_next ?? meta.pagination?.hasNext;
    if (rawHasNext != null && typeof rawHasNext !== 'boolean') throw fail();

    for (const item of items) {
      if (!item || typeof item !== 'object' || Array.isArray(item)) throw fail();
      const id = item.id ?? item.cp_id ?? item.cpId;
      if (id === null || id === undefined || String(id).trim() === '') throw fail();
      const key = String(id);
      if (seen.has(key)) throw fail();
      seen.add(key);
      rows.push(item);
    }
    if (expectedTotal !== null && rows.length > expectedTotal) throw fail();
    if (!items.length) {
      if (rawHasNext === true || (expectedTotal !== null && rows.length !== expectedTotal)) throw fail();
      return { rows };
    }
    if (rawHasNext === false || (expectedTotal !== null && rows.length === expectedTotal)) {
      if (rawHasNext === true || (expectedTotal !== null && rows.length !== expectedTotal)) throw fail();
      return { rows };
    }
    // Without reliable total/hasNext, continue until the server supplies an
    // empty page. A server ignoring page numbers is detected by duplicate IDs.
  }
  throw fail();
}
